






import { Component, Vue, Mixins, Prop, Watch, Model } from 'vue-property-decorator';

@Component({})
export default class ScalableBackground extends Vue {

    @Prop({required: true})
    public image?: string;

    public resizedWidth: string = '0px';
    public resizedHeight: string = '0px';
    public resizedLeft: string = '0px';

    private verboseLogging?: boolean = true;
    private imageSize?: {width: number, height: number};

    public style() {
        return {
            width: this.resizedWidth,
            height: this.resizedHeight,
            left: this.resizedLeft,
            backgroundImage: this.image ? 'url(' + this.image + ')' : 'none',
        };
    }

    @Watch('image')
    public async newImage() {
        if (this.image) {
            this.imageSize = await this.findImageSize(this.image);
        }
        this.doResize();
    }

    public async mounted() {
        // Register an event listener when the Vue component is ready
        window.addEventListener('resize', this.onResize);
        if (this.image && !this.imageSize) {
            await this.newImage();
        }
    }

    public beforeDestroy() {
    //   Unregister the event listener before destroying this Vue instance
        window.removeEventListener('resize', this.onResize);
    }

    private onResize() {
        this.doResize();
    }

    private findImageSize(image: string): Promise<{width: number, height: number}> {
        return new Promise((resolve, reject) => {
            const img = document.createElement('img');
            img.src = image;
            const poll = setInterval(() => {
                if (img.naturalWidth) {
                    clearInterval(poll);
                    resolve({
                        width: img.naturalWidth,
                        height: img.naturalHeight,
                    });
                }
            }, 10);

        });
    }


    private doResize() {
        const el = this.$el as HTMLElement;
        if (!this.imageSize || !el) {
            return;
        }

        const offsetTop = el.offsetTop;
        const imgPos = this.findPos(el);
        // console.log({imgWidth, imgHeight, offsetTop, pos});
        // We only want to scale it from the element position and down
        const footer = document.getElementsByClassName('view-footer').length
            ?  document.getElementsByClassName('view-footer')[0] as HTMLElement
            : null;

        const sizeOfBottomMenu = footer ? footer.offsetHeight : 0;
        const sizeOfMenu = sizeOfBottomMenu + imgPos.top;

        const scaleX = window.innerWidth / this.imageSize.width;
        const scaleY = (window.innerHeight - sizeOfMenu) / this.imageSize.height;

        const smallestScale = scaleX > scaleY ? scaleY : scaleX;

        const resizedImgWidth = Math.floor(this.imageSize.width * smallestScale);
        const resizedImgHeight = Math.floor(this.imageSize.height * smallestScale);
        const resizedImgLeftMargin = scaleX > scaleY
            ? Math.floor((window.innerWidth - resizedImgWidth) / 2)
            : 0;

        // console.log({sizeOfMenu, sizeOfBottomMenu, scaleX, scaleY, smallestScale });
        // // Do the resizing
        this.resizedWidth = resizedImgWidth + 'px';
        this.resizedHeight = resizedImgHeight + 'px';
        this.resizedLeft = resizedImgLeftMargin + 'px';

        this.$emit('resized', {width: resizedImgWidth, height: resizedImgHeight});
    }
    private findPos(obj: HTMLElement): {left: number, top: number} {
        let curLeft = 0;
        let currentTop = 0;

        if (obj.offsetParent) {
            do {
                curLeft += obj.offsetLeft;
                currentTop += obj.offsetTop;

                obj = obj.offsetParent as HTMLElement;
            } while (obj);

        }

        return { left: curLeft, top: currentTop };
    }
}


